/* PREVIEW MEGA MENU (tema 139512316113) — mega genérico estilo SpeedVegas (.irm): todos los .ihp-dd--irm. */
(function(){
  function isDesktop(){ return window.matchMedia('(min-width:901px)').matches; }
  function initOne(dd){
    var panel=dd.querySelector('.irm'), wrap=dd.querySelector('.irm-wrap'), main=dd.querySelector('[data-irm-main]');
    // Alto máximo = lo que queda de pantalla bajo el panel (la columna derecha hace scroll interno).
    function fit(){
      if(!isDesktop()||!wrap||!panel) return;
      var top=panel.getBoundingClientRect().top;
      if(top<0||top>window.innerHeight) return;
      wrap.style.setProperty('--irm-maxh', Math.max(320, Math.floor(window.innerHeight-top-12))+'px');
    }
    dd.addEventListener('mouseenter', function(){ requestAnimationFrame(fit); });
    dd.addEventListener('focusin', function(){ requestAnimationFrame(fit); });
    window.addEventListener('resize', fit);
    var tog=dd.querySelector('.irm-price-toggle');
    if(tog) tog.addEventListener('click', function(e){
      e.preventDefault(); e.stopPropagation();
      tog.setAttribute('aria-expanded', tog.getAttribute('aria-expanded')==='true'?'false':'true');
    });
    dd.querySelectorAll('[data-irm-jump]').forEach(function(a){
      a.addEventListener('click', function(e){
        var g=document.getElementById(a.getAttribute('data-irm-jump'));
        if(!g||!main) return; // sin grupo (p. ej. agotado): sigue el href de respaldo
        e.preventDefault();
        main.scrollTo({top:g.offsetTop-main.offsetTop,behavior:'smooth'});
        dd.querySelectorAll('[data-irm-jump]').forEach(function(x){ x.classList.toggle('is-active', x===a); });
        g.classList.add('is-flash'); setTimeout(function(){ g.classList.remove('is-flash'); },900);
      });
    });
    // Ocultar en el submenú los grupos que no se renderizaron (sin stock).
    dd.querySelectorAll('[data-irm-jump]').forEach(function(a){
      if(!document.getElementById(a.getAttribute('data-irm-jump'))) a.parentElement.style.display='none';
    });
  }
  function init(){ document.querySelectorAll('#iron-site-header .ihp-dd--irm').forEach(initOne); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
